import React from 'react';
import styled from 'styled-components';
import { UseSharedElement } from '@/components/use-shared-element';

export function FullScreenButton({
  sharedElement,
}: {
  sharedElement: UseSharedElement;
}) {
  return (
    <FullScreen type="button" onClick={sharedElement.show}>
      <svg
        width="46px"
        height="45px"
        viewBox="0 0 46 45"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Group 7</title>
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g
            id="130---CREATOS---womens---21---review---FINAL---code-editing"
            transform="translate(-3052.000000, -440.000000)"
            stroke="#5B656E"
            strokeWidth="5"
          >
            <g id="Group-7" transform="translate(3055.178056, 443.000000)">
              <polyline
                id="Path-4"
                points="0 25 0 38.8568159 12.434314 38.8568159"
              />
              <g id="Group-3" transform="translate(26.000000, 0.000000)">
                <polyline
                  id="Path-4-Copy"
                  transform="translate(6.717157, 6.428408) rotate(-180.000000) translate(-6.717157, -6.428408) "
                  points="0 1.63454375e-12 0 12.8568159 13.434314 12.8568159"
                />
                <line
                  x1="1"
                  y1="12.8568159"
                  x2="12.8568159"
                  y2="1"
                  id="Path-5-Copy"
                />
              </g>
              <line
                x1="0"
                y1="38.8568159"
                x2="11.8568159"
                y2="27"
                id="Path-5"
              />
            </g>
          </g>
        </g>
      </svg>
    </FullScreen>
  );
}

const FullScreen = styled.button`
  &:hover {
    cursor: pointer;
    opacity: 0.5;
  }
  svg {
    height: 15px;
  }
`;
